import { useEffect } from "react";
import { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { CaseTypeRuleTestRequest, CaseTypeRule } from "../../../../models";

import { StringDetailedResponse } from "../../../../models/swagger/generated-submission-service";
import { CaseTypeRulesService } from "../../../../services/ClientService";

export type CaseTypeRuleTestModalProps = {
    show: boolean;
    attorneyId?: string;
    county?: string;
    division?: string;
    csvCaseType?: string;
    csvSubCaseType?: string;
    efmeCaseType?: string;
    amount?: number;
    data?: CaseTypeRule;
    onSubmit: () => void;
    onClose: () => void;
};

export default function CaseTypeRuleTestModal({
    show,
    attorneyId,
    county,
    division,
    csvCaseType,
    csvSubCaseType,
    efmeCaseType,
    amount,
    onSubmit,
    onClose,
}: CaseTypeRuleTestModalProps) {
    const [rule, setRule] = useState({
        attorneyID: attorneyId,
        county: county,
        division: division,
        csvCaseType: csvCaseType,
        csvSubCaseType: csvSubCaseType,
        efmeCaseType: efmeCaseType,
        amount: amount,
    } as CaseTypeRuleTestRequest);

    const [data, setData] = useState("");

    useEffect(() => {
        setRule({
            attorneyID: attorneyId,
            county: county ?? "",
            division: division ?? "",
            csvCaseType: csvCaseType ?? "",
            csvSubCaseType: csvSubCaseType ?? "",
            efmeCaseType: efmeCaseType ?? "",
            amount: amount,
        });
    }, [
        show,
        attorneyId,
        county,
        division,
        csvCaseType,
        csvSubCaseType,
        amount,
        efmeCaseType,
    ]);

    const submitRule = () => {
        CaseTypeRulesService.getRule({
            body: {
                ...rule,
            },
        }).then(
            (resp) => {
                //onSubmit();
                setData(JSON.stringify(resp.data));
            },
            (error) => {
                console.log(error);
            }
        );
    };

    const closeWindow = () => {
        setData("");
        onClose();
    };

    return (
        <Modal
            show={show}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    CaseType Rule Test
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row form-group m-2">
                    <div className="col-sm-6">
                        <label>Attorney ID</label>
                        <input
                            className="form-control"
                            id="caseTypeRuleAttorneyID"
                            type="text"
                            defaultValue={rule.attorneyID}
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    attorneyID: event.currentTarget.value,
                                })
                            }
                        />
                    </div>
                    <div className="col-sm-6">
                        <label>County</label>
                        <input
                            className="form-control"
                            id="caseTypeRuleCounty"
                            type="text"
                            defaultValue={rule.county}
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    county: event.currentTarget.value,
                                })
                            }
                        />
                    </div>

                    <div className="col-sm-6">
                        <label>Division</label>
                        <input
                            className="form-control"
                            id="caseTypeRuleDivision"
                            type="text"
                            defaultValue={rule.division}
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    division: event.currentTarget.value,
                                })
                            }
                        />
                    </div>
                </div>

                <div className="row form-group m-2">
                    <div className="col-sm-12">
                        <label>CsvCaseType</label>
                        <input
                            className="form-control"
                            id="csvCaseType"
                            type="text"
                            defaultValue={rule.csvCaseType}
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    csvCaseType: event.currentTarget.value,
                                })
                            }
                        />
                    </div>
                </div>

                <div className="row form-group m-2">
                    <div className="col-sm-12">
                        <label>CsvSubCaseType</label>
                        <input
                            className="form-control"
                            id="csvSubCaseType"
                            type="text"
                            defaultValue={rule.csvSubCaseType}
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    csvSubCaseType: event.currentTarget.value,
                                })
                            }
                        />
                    </div>
                </div>

                <div className="row form-group m-2">
                    <div className="col-sm-12">
                        <label>Amount</label>
                        <input
                            className="form-control"
                            id="caseTypeRuleAmount"
                            type="number"
                            defaultValue={0}
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    amount: parseFloat(
                                        event.currentTarget.value
                                    ),
                                })
                            }
                        />
                    </div>
                </div>

                <div className="row form-group m-2">
                    <div className="col-sm-12">
                        <label>EfmeCaseType</label>
                        <input
                            className="form-control"
                            id="efmeCaseType"
                            type="text"
                            defaultValue={rule.efmeCaseType}
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    efmeCaseType: event.currentTarget.value,
                                })
                            }
                        />
                    </div>
                </div>
                <div className="row form-group m-2">
                    <div className="col-sm-12">
                        <label>Result:</label>
                        <label>{data}</label>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button className="btn-danger" onClick={closeWindow}>
                    Cancel
                </Button>
                <Button onClick={submitRule}>Submit</Button>
            </Modal.Footer>
        </Modal>
    );
}
